import { Module } from 'vuex';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';
import { AttendeeFixedCostState } from './types';
import { RootState } from '../../types';
import { state } from './state';

const namespaced: boolean = true;

export const attendeeFixedCostModule: Module<
  AttendeeFixedCostState,
  RootState
> = {
  namespaced,
  state,
  getters,
  actions,
  mutations,
};
